var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetstackLogoNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "237px",
    height: "237px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path3776",
    d: "M214.55,3.825l-157,157c-5,5 -5,13.2 0,18.2c5,5 13.2,5 18.2,0l157,-157c5,-5 5,-13.2 0,-18.2c-5,-5.1 -13.2,-5.1 -18.2,0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3778",
    d: "M204.55,88.625l-75.4,75.4c-5,5 -5,13.2 0,18.2c5,5 13.2,5 18.2,0l75.3,-75.3c5,-5 5,-13.2 0,-18.2c-4.9,-5.1 -13.1,-5.1 -18.1,-0.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3780",
    d: "M63.45,111.225c3.4,-0 6.7,-1.4 9.1,-3.8l75.3,-75.3c5,-5 5,-13.2 0,-18.2c-5,-5 -13.2,-5 -18.2,-0l-75.3,75.3c-5,5 -5,13.2 0,18.2c2.4,2.4 5.7,3.8 9.1,3.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3782",
    d: "M186.65,181.425l-33.3,33.3c-5,5 -5,13.2 0,18.2c5,5 13.2,5 18.2,0l33.3,-33.3c5,-5 5,-13.2 0,-18.2c-5,-5.1 -13.2,-5.1 -18.2,0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3784",
    d: "M55.25,31.725c-5,-5 -13.2,-5 -18.2,0l-33.3,33.3c-5,5 -5,13.2 0,18.2c5,5 13.2,5 18.2,0l33.3,-33.2c5,-5.1 5,-13.2 0,-18.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetstackLogoNegative);
export default __webpack_public_path__ + "static/media/jetstack-logo-negative.7673e67ce26f792dc1f20ca00eebdea6.svg";
export { ForwardRef as ReactComponent };